// History subsection form field enum
export enum HistoryFormField {
  HISTORY_FUNCTIONAL_LIMITATIONS = 'medical-background/history/functional-limitations',
  HISTORY_ACTIVITIES_PERMITTED = 'medical-background/history/activities-permitted',
  HISTORY_MEDICAL_HISTORY = 'medical-background/history/medical-history',
  HISTORY_SURGICAL_HISTORY = 'medical-background/history/surgical-history'
}
